module.exports = __webpack_public_path__ + "img/mediaPackages.1f91fd83.svg";